import { queryOptions, useMutation } from "@tanstack/react-query";
import instance, { ApiUrl } from "./axiosInstance";
import { Waste } from "types/waste.type";
import { NvRapporteringStatus } from "enums/NvRapporteringStatus.enum";

export enum WasteQueryKey {
  GetOne = "get-waste",
  GetList = "waste-get-list",
}

export const getWaste = (id: number) =>
  queryOptions({
    queryKey: [WasteQueryKey.GetOne, id],
    queryFn: async (): Promise<Waste> =>
      (await instance.get(`${ApiUrl.Waste}/${id}`)).data,
  });

export type GetWasteListParamsType = {
  // companyId: number;
  limit?: number;
  offset?: number;
  searchQuery?: string;
  onlyNv?: boolean;
  uppdragId?: number;
  status?: NvRapporteringStatus;
  customerId?: number;
};

type GetWasteListResponse = {
  items: Waste[];
  total: number;
  companyTotal: number;
};

export const getWasteList = (params?: GetWasteListParamsType) =>
  queryOptions({
    queryKey: [WasteQueryKey.GetList, params],
    queryFn: async (): Promise<GetWasteListResponse> =>
      (await instance.get(ApiUrl.Waste, { params })).data,
  });

export const useDeleteWaste = (settings = {}) =>
  useMutation({
    mutationFn: async (id: number) => {
      return instance.delete(`${ApiUrl.Waste}/${id}`);
    },
    ...settings,
  });
